import axios from "axios";
import {GET_ATTENDANCE_LIST, ADD_ATTENDANCE, UP_ATTENDANCE} from "../constant";

const { decorate, observable, action } = require("mobx");

class Attendance{
    list = [];
    isLoading = false;
    async getList(){
        try{
            this.isLoading = true;
            let response = await axios.get(GET_ATTENDANCE_LIST);
            let data = await response.data;
            this.list = data;
            this.isLoading = false;
        }catch(error){
            this.isLoading = false;
            throw error;
        }
    }

    async addAttendance(userid, lName, inTime){
        try{
            this.isLoading = true;
            let response = await axios.post(ADD_ATTENDANCE,{
                userid: userid,
                lName: lName,
                inTime: inTime,
            });
            await this.getList();
            this.isLoading = false;
        }catch(error){
            this.isLoading = false;
            throw error;
        }
    }

    async upAttendance(userid, lName, inTime, outTime){
        try{
            this.isLoading = true;
            let response = await axios.put(UP_ATTENDANCE,{
                userid: userid,
                lName: lName,
                inTime: inTime,
                outTime: outTime,
            });
            await this.getList();
            this.isLoading = false;
        }catch(error){
            this.isLoading = false;
            throw error;
        }
    }
}
decorate(Attendance, {
    list: observable,
    getList: action,
    addAttendance: action,
});

const attendance1 = new Attendance();
export default attendance1;
